<template>
  <v-select
    v-model="localValue"
    outlined
    dense
    hide-details
    item-color="primary"
    :items="
      setsLib.edges.filter(
        item => item.node.tag && item.node.tag.match(new RegExp('OLYMPIC'))
      )
    "
    label="Event"
    item-value="node.setId"
    clearable
    :rules="requiredRule"
    :hint="`${setId}`"
  >
    <template v-slot:item="data">
      {{ data.item.node.distance }} {{ data.item.node.stroke }}
    </template>
    <template v-slot:selection="data">
      {{ data.item.node.distance }} {{ data.item.node.stroke }}
    </template>
    <!--template v-slot:selection="data">
    {{ data.item.distance }} 
    </template-->
    <!--template slot="item" slot-scope="data">
        {{ data.distance }} - {{ data.stroke }}
    </template-->
  </v-select>
  <!--  CALL COMPONENT FROM PARENT EXAMPLE
              <AthletesDropdown v-on:change-athlete="onChangeAthlete"/>
              import AthletesDropdown from "../shared/athletes_dropdown_ex.vue";-->
</template>

<script>
import { mapGetters } from "vuex";
import { validation } from "../../mixins/validationMixin";

export default {
  props: ["parentValue"],
  mixins: [validation],
  model: {
    prop: "parentValue",
    event: "parentValueChange"
  },
  data() {
    return {
      setId: null
    };
  },
  computed: {
    ...mapGetters(["loading", "setsLib"]),
    localValue: {
      get: function() {
        return this.parentValue
          ? this.parentValue.toString()
          : this.parentValue;
      },
      set: function(value) {
        this.$emit("parentValueChange", value);
      }
    }
  },
  created() {
    this.handleGetSetsList();
    // if (!(Object.entries(this.$route.query).length === 0)) {
    //   const { setId } = this.$route.query;
    //   //assign to current instance variables
    //   this.localValue = setId;
    // }
  },
  methods: {
    handleGetSetsList() {
      //reach out of Vuex store, fire action that gets sets
      this.$store.dispatch("allSetsLib");
    }

    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the <template> call in the parent. The second parameter is the payload.
    // emitToParent (eevnt) {

    //   this.$emit('childToParent', this.childMessage)
    // }
  }
  // watch: {
  //   setId: function() {
  //     this.$emit("change-event", this.setId);
  //   }
  // }
};
</script>
